import React, {Component} from 'react';
import {connect} from 'react-redux';
import OptimizeButton from 'components/molecules/optimize-button';

class UsedTeamsContainer extends Component {
    countTeams(lineups) {
        let teamUsed = {};
        Object.keys(lineups).map((key) => {
            let lineup = lineups[key];

            for (let i in lineup.players) {
                let unit = lineup.players[i];
                let teamName = unit.team;

                if (teamUsed[teamName] === true) {
                    continue;
                }

                if (!teamUsed.hasOwnProperty(teamName)) {
                    teamUsed[teamName] = true;
                }
            }
        });
        return !isEmpty(teamUsed) ? Object.keys(teamUsed).length : 0;
    }

    render() {
        const {lineups} = this.props;
        const lineupsList = lineups.all();
        const teamsCount = this.countTeams(lineupsList);
        const lineupsCount = !isEmpty(lineupsList) ? Object.keys(lineupsList).length : 0;

        return (
            <div className="tab-content teams-content">
                <div className="players-heading">
                    <strong>{teamsCount}</strong> Teams Used |<strong>{lineupsCount}</strong> Lineups
                    <OptimizeButton />
                </div>
                {this.props.children}
            </div>
        );
    }
}

function mapStatesToProps(state) {
    const {usedPlayers, lineupsData, sportConfig} = state;
    return {
        sportConfig,
        usedPlayers: usedPlayers.players,
        lineups: lineupsData.lineups,
    };
}

export default connect(mapStatesToProps)(UsedTeamsContainer);
